import $ from 'jquery';
import BaseController from 'chairisher/_controller';
import Carousel from 'chairisher/component/carousel';

/**
 * Controller that binds actions for the Consign With Us page
 *
 * @class ConsignWithUsController
 * @constructs ConsignWithUsController
 */
class ConsignWithUsController extends BaseController {
    /** @inheritDoc * */
    bindPageActions() {
        // initialize carousel
        new Carousel({ $carousel: $('.js-carousel') }).bind();

        // bind tiered commission modal
        $('.js-tiered-commission-modal-trigger').on('click', () => {
            $('.js-professional-and-elite-tiered-commission-modal').modal('show');
        });

        // Scroll the seller plan matrix all the way to right on mobile
        const $sellerPlanMatrixContainer = $('.js-seller-plans-details-column');
        $sellerPlanMatrixContainer.scrollLeft($sellerPlanMatrixContainer.width());
    }
}

export default ConsignWithUsController;
